import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { MediaProfileContext } from "../../data/media_profile_context_management";
import useMediaProfileContactInfosApi from "../../data/use_media_profile_contact_infos_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import ContactInfoEditorActive from "../../../profiles/contact_info_editor/ContactInfoEditorActive";

const CONTACT_ERROR_LABELS = { value: "Value", value_type: "Type" };

// Contact info edit body. Reads the collection straight from MediaProfileContext (the provider owns
// it, from the same read the Connect card renders for an editable viewer — no modal-local fetch or
// loading state) and performs writes via use_media_profile_contact_infos_api. Same context-based
// shape as the other bodies, and the same editor the media outlet page uses.
function ContactModalBody({ close }) {
  const context = useContext(MediaProfileContext);
  const { contactInfos, generalError, isUpdating } = context;
  const { addContactInfo, removeContactInfo, updateContactInfo } = useMediaProfileContactInfosApi({ ...context });

  const contactInfoState = { contactInfos, addContactInfo, removeContactInfo, updateContactInfo, isUpdating };

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} labelMap={CONTACT_ERROR_LABELS} />
        <ContactInfoEditorActive contactInfoState={contactInfoState} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default ContactModalBody;
